export { default } from './DocumentInspector';
